const constants = {
    SERVER_URL: 'https://operator-service.tradetrackr.ru',
    DURATION_UNIT_OPTIONS: ['Minutes', 'Hours', 'Days', 'Weeks', 'Months'],
}

export default constants;
